import React, { useState } from 'react';
import { ShieldCheck, Mail, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const privacyContent = <>
    <h3 className="text-2xl font-bold mb-4" data-id="element-35">Política de Privacidad</h3>
    <p className="mb-4" data-id="element-36">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-37">
      1. Información que Recopilamos
    </h4>
    <p className="mb-3" data-id="element-38">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregarte el producto digital, incluyendo tu nombre y dirección de correo
      electrónico.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-39">2. Uso de la Información</h4>
    <p className="mb-3" data-id="element-40">
      Tu información se utiliza exclusivamente para: enviar el producto
      adquirido a tu correo electrónico, brindarte soporte relacionado con tu
      compra y enviarte actualizaciones del producto si las hubiera.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-41">3. Protección de Datos</h4>
    <p className="mb-3" data-id="element-42">
      Utilizamos cifrado SSL para proteger toda la información transmitida
      durante el proceso de compra. No almacenamos datos de tarjetas de crédito
      en nuestros servidores.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-43">4. Compartir Información</h4>
    <p className="mb-3" data-id="element-44">
      No vendemos, intercambiamos ni transferimos tu información personal a
      terceros. La única excepción son los proveedores de servicios de pago
      necesarios para procesar tu transacción.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-45">5. Cookies</h4>
    <p className="mb-3" data-id="element-46">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación y analizar el tráfico del sitio de forma anónima.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-47">6. Tus Derechos</h4>
    <p className="mb-3" data-id="element-48">
      Tienes derecho a solicitar la eliminación de tus datos personales en
      cualquier momento.
    </p>
  </>;
const termsContent = <>
    <h3 className="text-2xl font-bold mb-4" data-id="element-49">Términos y Condiciones</h3>
    <p className="mb-4" data-id="element-50">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-51">1. Producto Digital</h4>
    <p className="mb-3" data-id="element-52">
      "Metabolismo 40+ Reset" es un producto digital de carácter informativo y
      educativo. No sustituye el consejo médico profesional, diagnóstico o
      tratamiento.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-53">2. Entrega</h4>
    <p className="mb-3" data-id="element-54">
      El producto se entrega de forma inmediata por correo electrónico tras
      confirmar el pago. El acceso es de por vida una vez descargado el
      material.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-55">3. Uso Personal</h4>
    <p className="mb-3" data-id="element-56">
      El contenido adquirido es para uso personal e intransferible. Queda
      prohibida su reproducción, distribución o reventa sin autorización
      expresa.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-57">4. Resultados</h4>
    <p className="mb-3" data-id="element-58">
      Los resultados pueden variar de persona a persona. No garantizamos
      resultados específicos, ya que dependen de múltiples factores individuales
      como el estado de salud, la adherencia al protocolo y el estilo de vida.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-59">
      5. Descargo de Responsabilidad Médica
    </h4>
    <p className="mb-3" data-id="element-60">
      Este producto no pretende diagnosticar, tratar, curar ni prevenir ninguna
      enfermedad. Consulta siempre con tu médico antes de realizar cambios
      significativos en tu alimentación o estilo de vida.
    </p>

    <h4 className="text-lg font-bold mt-6 mb-2" data-id="element-61">6. Política de Reembolso</h4>
    <p className="mb-3" data-id="element-62">
      Debido a la naturaleza digital del producto, no se aceptan devoluciones
      una vez descargado el material.
    </p>
  </>;
type ModalType = 'privacy' | 'terms' | null;
export function FooterCTA() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-white py-12 px-6 text-center" data-id="element-63">
        <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-64">
          <div className="flex flex-col md:flex-row gap-6 md:gap-12 mb-8 text-cream/80" data-id="element-65">
            <div className="flex items-center gap-2 justify-center" data-id="element-66">
              <ShieldCheck size={20} className="text-sage" data-id="element-67" />
              <span data-id="element-68">Pago seguro cifrado</span>
            </div>
            <div className="flex items-center gap-2 justify-center" data-id="element-69">
              <Mail size={20} className="text-sage" data-id="element-70" />
              <span data-id="element-71">Entrega inmediata por correo electrónico</span>
            </div>
          </div>

          <div className="flex gap-6 mb-6" data-id="element-72">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-cream/60 hover:text-cream underline underline-offset-4 transition-colors" data-id="element-73">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-cream/60 hover:text-cream underline underline-offset-4 transition-colors" data-id="element-74">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm text-cream/50" data-id="element-75">
            © {new Date().getFullYear()} Metabolismo 40+ Reset. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-76">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-77">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white text-charcoal rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-78">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-charcoal transition-colors p-1" aria-label="Cerrar" data-id="element-79">
                <X size={24} data-id="element-80" />
              </button>

              <div className="pr-8 text-gray-700 leading-relaxed" data-id="element-81">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}